<div class="add-upload p-2 rounded">
  <div>

    <div [class.d-none]="!topText" class="w-100 d-flex justify-content-end align-items-center mb-1" style="font-weight: bold; font-size: smaller; color: var(--secondary)"> <i class="fas fa-location"></i> <span class="ml-1">{{topText}}</span></div>
    <div class="image-to-upload mb-2">
     
      <!--relative needed for cropper-->
      @if (convertedImageToShow) {
        <div class="position-relative" style="border-bottom: 1px solid black;">
          <img [src]="convertedImageToShow" #imageToBeCropped (click)="commonService.clickButton(fileUploadId)" />
          <div [class.d-none]="!showCropper" (pointerdown)="cropperDragStart($event)" (pointermove)="cropperDragContinue($event)" (pointerup)="cropperDragEnd()" style="border: 3px dashed var(--secondary); position: absolute; top: 0; left: 0" #cropper></div>
          <div class="my-2 d-flex w-100 justify-content-center">
            <button class="t-btn" *ngIf="convertedImageToShow" (click)="addRotateDegree(90)"><i class="fa fa-refresh"></i> Rotate</button>
         </div>
        </div>

        <p class="mt-2 w-100 text-start" style="color: var(--primary);">Result:</p>
        @if(uploadProgress){
            <div class="w-100">
                <div>Uploading...{{uploadProgress}}%</div>
                <div style="border-top: 3px solid var(--secondary);" class="mt-2" [ngStyle]="{width: uploadProgress + '%'}"></div>
            </div>
         
           
        }@else{
        <div class="w-100">
            <app-cropped-image [imgSrc]="convertedImageToShow" class="w-100" [cropInformation]="currentCropInformationToBeSaved"></app-cropped-image>

        </div>
        }
      } @else {
        <div class="d-flex w-100 justify-content-between justify-content-lg-center p-2 select-image-bar h-100 align-items-center">
          <span class="d-flex flex-column align-items-center h-100 justify-content-center px-4" (click)="commonService.clickButton(fileUploadId)"> <i class="fa fa-image text-center mb-2"></i> Select an image from my device </span>
          <span class="d-lg-none d-flex flex-column align-items-center h-100 justify-content-center px-4 camera-upload" (click)="commonService.clickButton(cameraUploadIdCamera)"> <i class="fa fa-camera text-center mb-2"></i> Select an image from my camera </span>
        </div>
      }
    </div>
  </div>

  <input type="file" accept="image/*" (change)="uploadImageChanged($event)" [id]="cameraUploadId" capture="environment" class="d-none" />
  <input type="file" accept="image/*" (change)="uploadImageChanged($event)" [id]="fileUploadId" class="d-none" />

  <input [(ngModel)]="currentUploadCaption" type="text" placeholder="Caption(optional)" class="my-2 caption-input p-2 rounded" />

  <div>
    <input type="checkbox" [(ngModel)]="showCropper" id="show-cropper"/>
    <label class="ml-2" for="show-cropper">Show Cropper</label>
  </div>

  <div class="w-100 d-flex justify-content-start align-items-center">
    <button class="btn btn-outline-primary" (click)="signalUploadImage()"><i class="fa fa-save"></i> Save</button>
  </div>
</div>
